import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/homepage/homepage.module').then(m => m.HomepageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/bem-vindo/bem-vindo.module').then(m => m.BemVindoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'customer',
    loadChildren: () => import('./pages/cliente/cliente.module').then(m => m.ClienteModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'quote',
    loadChildren: () => import('./pages/cotacao/cotacao.module').then(m => m.CotacaoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/pedido/pedido.module').then(m => m.PedidoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'factory',
    loadChildren: () => import('./pages/fabrica/fabrica.module').then(m => m.FabricaModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'revenue',
    loadChildren: () => import('./pages/faturamento/faturamento.module').then(m => m.FaturamentoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'manufacturing-order',
    loadChildren: () => import('./pages/ordem-de-fabricacao/ordem-de-fabricacao.module').then(m => m.OrdemDeFabricacaoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'receiving',
    loadChildren: () => import('./pages/recebimento/recebimento.module').then(m => m.RecebimentoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'request',
    loadChildren: () => import('./pages/requisicao/requisicao.module').then(m => m.RequisicaoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'contract',
    loadChildren: () => import('./pages/contrato/contrato.module').then(m => m.ContratoModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'label-technip',
    loadChildren: () => import('./pages/etiqueta-technip/etiqueta-technip.module').then(m => m.EtiquetaTechnipModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'label-filial',
    loadChildren: () => import('./pages/etiquetas-filial/etiquetas-filial.module').then(m => m.EtiquetasFilialModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'packing-list',
    loadChildren: () => import('./pages/romaneio/romaneio.module').then(m => m.RomaneioModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'collection-request',
    loadChildren: () => import('./pages/solicitacao-coleta/solicitacao-coleta.module').then(m => m.SolicitacaoColetaModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'packing',
    loadChildren: () => import('./pages/packing/packing.module').then(m => m.PackingModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'document-export',
    loadChildren: () => import('./pages/documentacao-me/documentacao-me.module').then(m => m.DocumentacaoMeModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'visit-report',
    loadChildren: () => import('./pages/relatorio-de-visitas/relatorio-de-visitas.module').then(m => m.RelatorioDeVisitasModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'bom',
    loadChildren: () => import('./pages/bom/bom.module').then(m => m.BomModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'drawback',
    loadChildren: () => import('./pages/drawback/drawback.module').then(m => m.DrawbackModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'conformity-certificate',
    loadChildren: () => import('./pages/certificado-conformidade/certificado-conformidade.module').then(m => m.CertificadoConformidadeModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'teadit-store',
    loadChildren: () => import('./pages/portal-de-pedidos/portal-de-pedidos.module').then(m => m.PortalDePedidosModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'opportunity',
    loadChildren: () => import('./pages/oportunidade/oportunidade.module').then(m => m.OportunidadeModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'embalagens',
    loadChildren: () => import('./pages/embalagens/embalagens.module').then(m => m.EmbalagensModule),
    canActivate: [
      MsalGuard,
    ]
  },
  {
    path: 'customer-date-change',
    loadChildren: () => import('./pages/alteracoes-data-cliente/alteracao-data-cliente-routing.module').then(m => m.AlteracaoDataClienteRoutingModule),
    canActivate: [
      MsalGuard,
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
